require('leaflet/dist/leaflet.css')
require('leaflet.markercluster/dist/MarkerCluster.Default.css')
require('leaflet.markercluster/dist/MarkerCluster.css')
require('leaflet.zoomhome/src/css/leaflet.zoomhome.css')
require('font-awesome/css/font-awesome.min.css')
require('../css/site.css')

import * as $ from 'jquery';
import loadMap from "./map";

$(function () {
    loadMap();
});
